import Image from 'next/image'

import { STATIC_URL } from 'constants/data'

import styles from './sber-badge.module.scss'

const sberHealthLogoData = {
  src: `${STATIC_URL}/courses/sber-health-logo.png`,
  width: 171,
  height: 20,
  alt: 'Cбер Здоровье',
}

const SberBadge = () => {
  return (
    <div className={styles.badge}>
      <p className={styles.text}>Программа</p>
      <Image {...sberHealthLogoData} />
    </div>
  )
}

export default SberBadge
